import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import contact from '../images/Navbar/contact.png'
import mail from '../images/Navbar/mail.png'
import twitter from '../images/Navbar/twitter.png'
import facebook from '../images/Navbar/facebook.png'
import insta from '../images/Navbar/insta.png'
import dropdown from '../images/Navbar/dropdown.png'
import smallsearch from '../images/Navbar/smallsearch.png'
import cart from '../images/Navbar/cart.png'
import profile from '../images/Navbar/profile.png'
// import logo from '../images/Navbar/logomob.png'
import logo from '../images/Navbar/logo.png'
import { decrypt } from '../crypto'
import { useDispatch, useSelector } from 'react-redux';
import LiveViews from '../pages/LiveViews'
import animationData from "../lotties/Live.json";
import Lottie from "lottie-react";
import axios from 'axios'

function NavbarMob() {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const navigate = useNavigate()
    const [searchQuery, setSearchQuery] = useState('');

    const admin = useSelector((state) => state.user.admin);

    // const [admin, setAdmin] = useState(null)

    // useEffect(() => {
    //     const isAdmin = localStorage.getItem('i_a');
    //     if (isAdmin) {
    //         setAdmin(decrypt(isAdmin))
    //     }
    // }, [localStorage])

    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

    // Function to toggle sidebar
    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const accountPage = () => {
        navigate('/account')
    }

    const homePage = () => {
        navigate('/')
        window.location.reload();
    }

    const cartpage = () => {
        navigate('/cart')
    }

    const handleSearch = () => {
        if (searchQuery.trim() !== '') {
            navigate('/searchpage', { state: { filtered: searchQuery } });
        }
    };

    const mensubcategorypage = (categoryId) => {
        navigate(`/subcategoryproducts?c=${btoa('627')}&n=${btoa("MEN'S")}`, { state: { categoryId: 627, categoryName: "MEN'S" } });
    };

    const womensubcategorypage = (categoryId) => {
        navigate(`/subcategoryproducts?c=${btoa('628')}&n=${btoa("WOMEN'S")}`, { state: { categoryId: 628, categoryName: "WOMEN'S" } });
    };

    const kidssubcategorypage = (categoryId) => {
        navigate(`/subcategoryproducts?c=${btoa('629')}&n=${btoa("KID'S")}`, { state: { categoryId: 629, categoryName: "KID'S" } });
    };

    const limitedsalesubcategorypage = (categoryId) => {
        navigate(`/subcategoryproducts?c=${btoa('0')}&n=${btoa("LIMITED SALE")}`, { state: { categoryId: 0, categoryName: "LIMITED SALE" } });
    };

    const bestsellersubcategorypage = (categoryId) => {
        navigate(`/subcategoryproducts?c=${btoa('0')}&n=${btoa("BEST SELLER")}`, { state: { categoryId: 0, categoryName: "BEST SELLER" } });
    };

    const newarrival = (categoryId, categoryName) => {
        navigate(`/subcategoryproducts?c=${btoa('0')}&n=${btoa("NEW ARRIVAL")}`, { state: { categoryId: 0, categoryName: 'NEW ARRIVAL' } });
    };

    const dashboardpage = () => {
        navigate('/dashboard');
    }

    const checkImageExistsFirstColor = async (image) => {
        // Check cache first
        if (imageValidationCache.current[image] !== undefined) {
            return imageValidationCache.current[image];
        }

        try {
            const res = await fetch(`${apiLocalUrl}/check-image/${encodeURIComponent(image)}`);

            if (!res.ok) {
                imageValidationCache.current[image] = false;
                return false;
            }

            const data = await res.json();
            const result = data.exists;

            // Cache the result
            imageValidationCache.current[image] = result;
            return result;
        } catch (err) {
            imageValidationCache.current[image] = false;
            return false;
        }
    };

    const getFirstAvailableColor = async (productId) => {
        try {
            const response = await axios.get(`${apiBaseUrl}/getProductDetails/BLACKBATON_2526?Id=${productId}`);
            if (response.status === 200) {
                const data = response.data;
                const distinctColors = [...new Set(
                    data.filter(item => item.ItemId === productId).map(item => item.Color?.trim()).filter(Boolean)
                )];

                // Check colors in order
                for (const color of distinctColors) {
                    const exists = await checkImageExistsFirstColor(`${productId}_${color}.webp`);
                    if (exists) {
                        return color;
                    }
                }
                return null;
            }
        } catch (error) {
            console.error('Error fetching product details:', error);
            return null;
        }
    };

    // Helper function to check if an image exists and is accessible
    const checkImageExists = async (imageCode) => {
        if (!imageCode) return false;

        // Check cache first
        if (imageValidationCache.current[imageCode] !== undefined) {
            return imageValidationCache.current[imageCode];
        }

        try {
            // displayFirst already includes .webp extension, so don't add it again
            const imageUrl = imageCode.endsWith('.webp')
                ? `${apiLocalUrl}/uploads/${imageCode}`
                : `${apiLocalUrl}/uploads/${imageCode}.webp`;

            const response = await fetch(imageUrl, {
                method: 'HEAD',
                cache: 'no-cache'
            });
            const result = response.ok;

            // Cache the result
            imageValidationCache.current[imageCode] = result;
            return result;
        } catch (error) {
            imageValidationCache.current[imageCode] = false;
            return false;
        }
    };

    const handleSearchValue = async (val) => {

        if (val === '' || val === undefined || val === null) {

            setSearchProducts([]);
            setSearchLoading(false);
            return
        }

        setSearchLoading(true);
        try {

            const response = await fetch(
                `${apiBaseUrl}/getProductByFilter/BLACKBATON_2526?filter=${encodeURIComponent(val)}`
            );


            // Check if the response is OK (status code 200-299)
            if (!response.ok) {
                throw new Error(`API request failed with status ${response.status}`);
            }

            // Parse the response as JSON
            const data = await response.json();

            // Handle both array and object responses
            // API might return [product, product] OR { products: [product], pagination: {...} }
            const productsList = Array.isArray(data) ? data : (data.products || []);

            // Validate that we have an array
            if (Array.isArray(productsList)) {
                const validProducts = productsList
                    .filter(item => item?.ItemName && item?.ID)
                    .map(item => {
                        let image = item.displayFirst;
                        if (image && !image.endsWith('.webp')) {
                            image = `${image}.webp`;
                        }
                        return {
                            Id: item.ID,
                            ItemName: item.ItemName.toUpperCase(),
                            displayFirst: image
                        };
                    })
                    .slice(0, 15); // Limit to first 15 results for faster processing

                setSearchProducts(validProducts);
                setSearchLoading(false);
            } else {
                console.error("API response format invalid (expected array or object with products):", data);
                setSearchProducts([]);
                setSearchLoading(false);
            }
        } catch (error) {
            console.error('Error fetching products:', error);
            setSearchProducts([]); // Set products to an empty array if an error occurs
            setSearchLoading(false);
        }
    };

    const [searchProducts, setSearchProducts] = useState([])
    const apiLocalUrl = process.env.REACT_APP_API_LOCAL_URL;
    const [searchLoading, setSearchLoading] = useState(false)

    // Cache for image validation results
    const imageValidationCache = React.useRef({});

    const handleOnBlur = () => {
        setTimeout(() => setSearchProducts([]), 200);
    }

    const handleOnFocus = () => {
        if (searchQuery === '' || searchQuery.length < 1) return
        handleSearchValue(searchQuery)
    }

    // Debounce timer ref
    const searchTimeoutRef = React.useRef(null);

    const handleSearchQuery = (e) => {
        const val = e.target.value

        setSearchQuery(val)

        // Clear existing timeout
        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }

        if (val === '' || val.length < 1) {
            setSearchProducts([]);
            return;
        }

        // Set new timeout for debounced search
        searchTimeoutRef.current = setTimeout(() => {
            handleSearchValue(val);
        }, 150); // 150ms debounce delay for faster response
    }

    function encodeBase64(text) {
        return btoa(text);
    }

    const fullimage = (id, itemName) => {
        setSearchProducts([]);
        setSearchQuery('');
        navigate(`/fullimage?I=${encodeBase64(String(id))}&N=${encodeBase64(itemName)}`, { state: { id, itemName } });
    };

    return (
        <div className='w-full h-auto bg-gradient-to-b from-black via-gray-900 to-black flex flex-col fixed top-0 left-0 z-50 shadow-2xl border-b border-gray-800'>

            {/* Premium Single Row Header */}
            <div className='w-full px-3 py-3 flex items-center gap-3'>
                {/* Menu Icon with Container */}
                <div className='flex-shrink-0 w-9 h-9 rounded-xl bg-white/10 backdrop-blur-sm flex items-center justify-center hover:bg-white/20 transition-all cursor-pointer border border-white/10'>
                    <img className='w-4 h-4' src={dropdown} alt="menu" onClick={toggleSidebar} />
                </div>

                {/* Logo with Glow Effect */}
                {/* <div className='flex-shrink-0 cursor-pointer' onClick={homePage}>
                    <img src={logo} alt="logo" className='h-6 invert drop-shadow-[0_0_8px_rgba(255,255,255,0.3)]' />
                </div> */}

                {/* Premium Search Bar with Glassmorphism */}
                <div className='flex-grow relative min-w-0'>
                    <div className='relative'>
                        <input
                            type="text"
                            className='w-full h-9 outline-none px-3 py-2 rounded-xl text-xs font-dmSans bg-white/95 backdrop-blur-md shadow-lg border border-gray-200/50 focus:border-white focus:ring-2 focus:ring-white/50 transition-all placeholder:text-gray-400'
                            placeholder='Search products...'
                            value={searchQuery}
                            onChange={(e) => handleSearchQuery(e)}
                            onBlur={handleOnBlur}
                            onFocus={handleOnFocus}
                            onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
                        />
                        {/* Search Icon Inside Input */}
                        <div className='absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none'>
                            <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                            </svg>
                        </div>
                    </div>
                    {(searchLoading || searchProducts.length > 0) && (
                        <div className="fixed top-[60px] left-0 right-0 mx-3 max-h-[calc(100vh-60px)] bg-white shadow-2xl rounded-2xl border border-gray-200 overflow-hidden z-[60] animate-in overflow-y-auto">
                            <div className="p-3 bg-gradient-to-r from-gray-50 to-gray-100 border-b border-gray-200 text-xs font-bold text-gray-600 tracking-widest uppercase">
                                {searchLoading ? 'Searching...' : ` ${searchProducts.length} Results`}
                            </div>

                            {searchLoading ? (
                                // Shimmer loading skeleton
                                Array.from({ length: searchProducts.length || 1 }).map((_, index) => (
                                    <div
                                        key={`skeleton-${index}`}
                                        className="w-full p-3 flex items-center gap-4 border-b border-gray-50 last:border-0 animate-pulse"
                                        style={{ opacity: 1 - index * 0.25 }}
                                    >
                                        <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-gray-200 to-gray-300 flex-shrink-0"></div>
                                        <div className="flex flex-col gap-2 flex-grow">
                                            <div className="h-4 bg-gradient-to-r from-gray-200 to-gray-300 rounded w-3/4"></div>
                                            <div className="h-3 bg-gradient-to-r from-gray-100 to-gray-200 rounded w-1/2"></div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                searchProducts.map((pro, index) => (
                                    <div
                                        key={pro.Id}
                                        className="w-full p-3 flex items-center gap-3 hover:bg-gradient-to-r hover:from-gray-50 hover:to-white transition-all cursor-pointer border-b border-gray-50 last:border-0 group"
                                        onMouseDown={() => {
                                            fullimage(pro.Id, pro.ItemName);
                                        }}
                                    >
                                        <div className="w-12 h-12 rounded-xl bg-gray-100 overflow-hidden flex-shrink-0 border border-gray-200 shadow-sm group-hover:shadow-md transition-shadow">
                                            <img
                                                src={pro.displayFirst ? `${apiLocalUrl}/uploads/${pro.displayFirst}` : smallsearch}
                                                alt={pro.ItemName}
                                                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = smallsearch;
                                                }}
                                            />
                                        </div>
                                        <div className="flex flex-col overflow-hidden flex-grow">
                                            <span className="text-xs font-bold text-left text-gray-800 truncate uppercase group-hover:text-black transition-colors">
                                                {pro.ItemName}
                                            </span>
                                        </div>
                                        <svg className="w-4 h-4 text-gray-300 group-hover:text-gray-600 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                                        </svg>
                                    </div>
                                ))
                            )}
                        </div>
                    )}
                </div>

                {/* Premium Cart Icon */}
                <div className='flex-shrink-0 relative'>
                    <div className='w-9 h-9 rounded-xl bg-white/10 backdrop-blur-sm flex items-center justify-center hover:bg-white/20 transition-all cursor-pointer border border-white/10 group' onClick={cartpage}>
                        <img src={cart} alt="cart" className='w-5 h-5 group-hover:scale-110 transition-transform' />
                    </div>
                </div>

                {/* Premium Profile Icon */}
                {/* <div className='flex-shrink-0'>
                    <div className='w-9 h-9 rounded-xl bg-white/10 backdrop-blur-sm flex items-center justify-center hover:bg-white/20 transition-all cursor-pointer border border-white/10 group' onClick={accountPage}>
                        <img src={profile} alt="profile" className='w-5 h-5 group-hover:scale-110 transition-transform' />
                    </div>
                </div> */}
            </div>

            {/* Premium Sidebar Component */}
            {isSidebarOpen && (
                <div className='relative'>
                    {/* Premium Background Blur */}
                    <div
                        className="fixed inset-0 bg-black/60 backdrop-blur-md z-40 animate-in fade-in duration-300"
                        onClick={toggleSidebar}
                    ></div>

                    {/* Premium Sidebar */}
                    <div className={`fixed top-0 left-0 w-[280px] h-screen bg-white text-black z-50 shadow-2xl transition-transform duration-500 ease-out ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'}`}>
                        <div className='w-full h-screen flex flex-col'>

                            {/* Premium Header with Glassmorphism */}
                            <div className='w-full flex flex-row bg-white/90 backdrop-blur-xl p-4 border-b border-gray-200'>
                                <div className='w-full flex flex-row gap-3 justify-start items-center'>
                                    <div className='w-8 h-8 rounded-lg bg-gray-100 flex items-center justify-center'>
                                        <img className='w-4 h-4' src={contact} alt="contact" />
                                    </div>
                                    <a href="tel:+919995028039" className='hover:text-black/70 transition-colors'>
                                        <span className='text-xs font-medium font-dmSans text-gray-600'>+91 9995028039</span>
                                    </a>
                                </div>
                                <button onClick={toggleSidebar} className="text-black w-max h-max flex justify-end items-end group">
                                    <div className='w-8 h-8 rounded-lg bg-gray-100 hover:bg-gray-200 flex justify-center items-center transition-all group-hover:rotate-90 duration-300'>
                                        <span className='text-2xl font-light'>×</span>
                                    </div>
                                </button>
                            </div>

                            {/* Menu Content with Scroll */}
                            <div className='w-full flex-grow overflow-auto scrollbar-thin scrollbar-thumb-white/20 scrollbar-track-transparent text-left'>

                                {/* Home Section */}
                                <div className='px-3 py-2'>
                                    <div
                                        className='p-3 rounded-xl hover:bg-gray-50 cursor-pointer transition-all duration-300 group'
                                        onClick={() => { homePage(); setIsSidebarOpen(false); }}
                                    >
                                        <span className='text-sm font-semibold font-dmSans text-gray-800 group-hover:text-black transition-colors'>Home</span>
                                    </div>
                                </div>

                                <div className='w-full h-[1px] bg-gray-100 my-2'></div>

                                {/* Categories Section */}
                                <div className='px-3 py-2'>
                                    <p className='text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-2 px-3'>Categories</p>
                                    <div className='space-y-1'>
                                        <div className='p-3 rounded-xl hover:bg-gray-50 cursor-pointer transition-all duration-300 group' onClick={() => { mensubcategorypage(); setIsSidebarOpen(false); }}>
                                            <span className='text-sm font-medium font-dmSans text-gray-600 group-hover:text-black transition-colors'>Men</span>
                                        </div>
                                        <div className='p-3 rounded-xl hover:bg-gray-50 cursor-pointer transition-all duration-300 group' onClick={() => { womensubcategorypage(); setIsSidebarOpen(false); }}>
                                            <span className='text-sm font-medium font-dmSans text-gray-600 group-hover:text-black transition-colors'>Women</span>
                                        </div>
                                        <div className='p-3 rounded-xl hover:bg-gray-50 cursor-pointer transition-all duration-300 group' onClick={() => { kidssubcategorypage(); setIsSidebarOpen(false); }}>
                                            <span className='text-sm font-medium font-dmSans text-gray-600 group-hover:text-black transition-colors'>Kids</span>
                                        </div>
                                        <div className='p-3 rounded-xl hover:bg-gray-50 cursor-pointer transition-all duration-300 group' onClick={() => { limitedsalesubcategorypage(); setIsSidebarOpen(false); }}>
                                            <span className='text-sm font-medium font-dmSans text-gray-600 group-hover:text-black transition-colors'>Limited Sale</span>
                                        </div>
                                        <div className='p-3 rounded-xl hover:bg-gray-50 cursor-pointer transition-all duration-300 group' onClick={() => { bestsellersubcategorypage(); setIsSidebarOpen(false); }}>
                                            <span className='text-sm font-medium font-dmSans text-gray-600 group-hover:text-black transition-colors'>Best Seller</span>
                                        </div>
                                        <div className='p-3 rounded-xl hover:bg-gray-50 cursor-pointer transition-all duration-300 group' onClick={() => { newarrival(); setIsSidebarOpen(false); }}>
                                            <span className='text-sm font-medium font-dmSans text-gray-600 group-hover:text-black transition-colors'>New Arrivals</span>
                                        </div>
                                        {admin === '1' && (
                                            <div className='p-3 rounded-xl hover:bg-gradient-to-r hover:from-purple-500/20 hover:to-pink-500/20 cursor-pointer transition-all duration-300 group border border-purple-500/20' onClick={dashboardpage}>
                                                <span className='text-sm font-semibold font-dmSans text-purple-300 group-hover:text-purple-200 transition-colors'>Dashboard</span>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className='w-full h-[1px] bg-gradient-to-r from-transparent via-white/10 to-transparent my-2'></div>

                                {/* Account Section */}
                                <div className='px-3 py-2'>
                                    <p className='text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-2 px-3'>Account</p>
                                    <div className='space-y-1'>
                                        <div className='p-3 rounded-xl hover:bg-gray-50 cursor-pointer transition-all duration-300 group' onClick={() => { cartpage(); setIsSidebarOpen(false); }}>
                                            <span className='text-sm font-medium font-dmSans text-gray-600 group-hover:text-black transition-colors'>Cart</span>
                                        </div>
                                        <div className='p-3 rounded-xl hover:bg-gray-50 cursor-pointer transition-all duration-300 group' onClick={() => { accountPage(); setIsSidebarOpen(false); }}>
                                            <span className='text-sm font-medium font-dmSans text-gray-600 group-hover:text-black transition-colors'>Account</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Premium Footer with Logo and Social */}
                            <div className='w-full h-max flex flex-row bg-gray-50 border-t border-gray-100 p-4'>
                                <img className='w-16 opacity-80 hover:opacity-100 transition-opacity cursor-pointer' src={logo} alt="logo" onClick={homePage} />
                                <div className='w-full flex flex-row justify-end items-center gap-2'>
                                    <a
                                        href="https://www.facebook.com/share/1DoGh3dsmd/?mibextid=wwXIfr"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className='group'
                                    >
                                        <div className='w-9 h-9 rounded-xl bg-white hover:bg-blue-50 flex justify-center items-center transition-all hover:scale-110 border border-gray-200'>
                                            <img className='w-4' src={facebook} alt="facebook" />
                                        </div>
                                    </a>
                                    <a
                                        href="https://www.instagram.com/black_baton?igsh=MXE0MG43cDV5ZHdrOQ%3D%3D&utm_source=qr"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className='group'
                                    >
                                        <div className='w-9 h-9 rounded-xl bg-white hover:bg-pink-50 flex justify-center items-center transition-all hover:scale-110 border border-gray-200'>
                                            <img className='w-4' src={insta} alt="insta" />
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            )}
        </div>
    )
}

export default NavbarMob
